export default {"src":"/oferta/_next/static/media/play.0da76346.svg","height":960,"width":960,"blurWidth":0,"blurHeight":0};